// @ts-strict-ignore
import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-panel',
    templateUrl: './panel.component.html',
    styleUrls: ['./panel.component.scss'],
    standalone: false
})
export class PanelComponent {
  @Input() collapsed: boolean = false;
  @Input() collapsible: boolean = true;
  /**the max height, added with css-value, such as 300px, 12 rem */
  @Input() contentMaxHeight: string | undefined = undefined;
  @Input() headerContent: string;
  /**
   * If set to true no padding will be added between the border and content.
   */
  @Input() tight: boolean = false;
  @Input() title: string;

  onBeforeToggle(event) {
    if (this.collapsible) {
      this.collapsed = !this.collapsed;
    }
  }
}
